import { FileText, FileSpreadsheet, FileJson, Box, Archive, ClipboardCopy } from "lucide-react";
import { EXPORTS } from "./data";
import { Reveal, SectionHead } from "./Primitives";

const icon = (n) => /PDF/.test(n) ? FileText : /CSV/.test(n) ? FileSpreadsheet : /JSON/.test(n) ? FileJson : /PDB/.test(n) ? Box : /ZIP/.test(n) ? Archive : ClipboardCopy;

export const Exports = () => (
  <section id="exports" data-testid="exports-section" className="relative py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHead eyebrow="Download catalog" title={<>Sixteen exports. <span className="text-[var(--muted)]">Each says what it is.</span></>} body="PDF reports, tabular CSVs, analysis JSON and refined PDB coordinates — with fresh comparisons clearly separated from archived evidence." />
      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 rounded-xl overflow-hidden bg-[var(--surface)] border-l border-t border-[var(--line)]">
        {EXPORTS.map((e, i) => {
          const I = icon(e.n);
          return (
            <Reveal key={e.n} delay={(i % 4) * 0.05} className="border-r border-b border-[var(--line)]">
              <div data-testid={`export-item-${i}`} className="group h-full p-6 hover:bg-[var(--surface-2)] transition-colors">
                <I className="h-5 w-5 text-[var(--teal)] group-hover:scale-110 transition-transform" />
                <h3 className="mt-5 font-semibold">{e.n}</h3>
                <p className="mt-1 font-mono text-[11px] text-[var(--teal)]">{e.w}</p>
                <p className="mt-3 text-sm text-[var(--muted)] leading-relaxed">{e.d}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
